import React from 'react';
import PlayerStatsTable from '../components/PlayerStatsTable';
import PlayerHero from '../components/PlayerHero';
import { getPlayerInformation, getPlayerStats } from '../utils/player';
import { useTeamLogos } from '../hooks/team';
import { usePlayer } from '../hooks/player';

function Player() {
  const [player, loadingPlayer, errorPlayer] = usePlayer(window?.pageData?.id);
  const playerInformation =
    !loadingPlayer && player ? getPlayerInformation(player) : null;
  const playerStats =
    !loadingPlayer && player ? getPlayerStats(player?.stats) : null;
  const [teamLogos, loading, error] = useTeamLogos();

  return (
    <>
      <section className="site-container site-container--hug-on-mobile">
        {playerInformation && (
          <PlayerHero
            playerInformation={playerInformation}
            teamLogos={teamLogos}
          />
        )}
      </section>
      <section className="site-container">
        <div className="row">
          <div className="col-12">
            {playerStats && (
              <PlayerStatsTable
                playerStats={playerStats || []}
                teamLogos={teamLogos}
              />
            )}
          </div>
        </div>
      </section>
    </>
  );
}

export default Player;
